<template>
  <label class="bee-switch">
    <input class="switch-input" :disabled="disabled" @change="$emit('change', param, currentValue)" type="checkbox" v-model="currentValue">
    <span class="switch-core"></span>
    <div class="switch-label">
      <slot></slot>
    </div>
  </label>
</template>

<script>
/**
 * switchBtn
 * @module components/switch
 * @desc 切换按钮
 * @param {boolean} [value] - 绑定值，支持双向绑定
 * @param {slot} - 显示内容
 *
 * @example
 * <switch v-model="value"></switch>
 */
export default {
  name: 'BeeSwitch',
  props: {
    param: Object,
    value: Boolean,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/switch/switch.vue